import { get } from '.';

export function GetXtimeLink(options = {}) {
	return get<any>("/app/api/xtime_link", options);
}
